import React, { Suspense } from 'react';
import { CircularProgress, Box } from '@mui/material';

// Lazy load components for code splitting
const LandingPage = React.lazy(() => import('../pages/LandingPage'));
const AboutUsPage = React.lazy(() => import('../pages/AboutUsPage/AboutUsPage'));
const Services = React.lazy(() => import('../pages/Services'));
const Features = React.lazy(() => import('../pages/Features'));
// const Pricing = React.lazy(() => import('../pages/Pricing'));
const ContactUs = React.lazy(() => import('../pages/ContactUs'));
const BlogPage = React.lazy(() => import('../pages/Blog'));
const Careers = React.lazy(() => import('../pages/Careers'));
const BecomeAPartner = React.lazy(() => import('../pages/BecomeAPartner/Index'));

// Location pages
const DelhiPage = React.lazy(() => import('../pages/Locations/Delhi'));
const MumbaiPage = React.lazy(() => import('../pages/Locations/Mumbai'));
const BangalorePage = React.lazy(() => import('../pages/Locations/Bangalore'));

// Loading component
const PageLoader = () => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    minHeight="50vh"
  >
    <CircularProgress size={60} />
  </Box>
);

// Higher-order component for lazy loading with error boundary
const withLazyLoading = (Component) => {
  return React.forwardRef((props, ref) => (
    <Suspense fallback={<PageLoader />}>
      <Component {...props} ref={ref} />
    </Suspense>
  ));
};

// Export lazy-loaded components
export const LazyLandingPage = withLazyLoading(LandingPage);
export const LazyAboutUsPage = withLazyLoading(AboutUsPage);
export const LazyServices = withLazyLoading(Services);
export const LazyFeatures = withLazyLoading(Features);
// export const LazyPricing = withLazyLoading(Pricing);
export const LazyContactUs = withLazyLoading(ContactUs);
export const LazyBlogPage = withLazyLoading(BlogPage);
export const LazyCareers = withLazyLoading(Careers);
export const LazyBecomeAPartner = withLazyLoading(BecomeAPartner);

// Location pages
export const LazyDelhiPage = withLazyLoading(DelhiPage);
export const LazyMumbaiPage = withLazyLoading(MumbaiPage);
export const LazyBangalorePage = withLazyLoading(BangalorePage);
